import React, { useEffect, useState, useCallback } from "react";
import {
    Card,
    CardContent,
    Typography,
    List,
    ListItem,
    Avatar,
    Divider,
    Button,
    Box,
    Skeleton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { get } from "../../services/api-services";
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';

const Registration = ({ parentLoading }) => {
    const nav = useNavigate();
    const [recentlyEnrolledPrograms, setRecentlyEnrolledPrograms] = useState([]);
    const [totalEnrolled, setTotalEnrolled] = useState(0);
    const [loading, setLoading] = useState(true);

    const fetchTotalEnroll = useCallback(async () => {
        try {
            // Using /Customers/count to fetch total enrolled users
            const response = await get(`/Customers/count?where={"role":"user"}`);
            setTotalEnrolled(response.data.count);
        } catch (error) {
            console.error("Error fetching total enroll count:", error);
        }
    }, []);

    const fetchRecentlyEnrolledPrograms = useCallback(async () => {
        setLoading(true);
        try {
            const response = await get(
                `/Customers?filter={"where": {"role": "user"},"order":"createdAt DESC", "limit" : "5"}`
            );

            // Map response to format data

            const programs = response?.data?.map((item) => {
                const formattedDate = new Date(item?.createdAt).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                });

                return {
                    id: item.id,
                    name: item.name,
                    createdAt: formattedDate,
                    avatarUrl: "",
                };
            });

            setRecentlyEnrolledPrograms(programs || []);
        } catch (error) {
            console.error("Error fetching recently enrolled programs:", error);
        }
        setLoading(false);
    }, []);

    // Fetch both data on mount
    useEffect(() => {
        fetchRecentlyEnrolledPrograms();
        fetchTotalEnroll();
    }, [fetchRecentlyEnrolledPrograms, fetchTotalEnroll]);

    const handleClick = () => {
        nav("/admin/cases");
    };

    return (
        <Card className="flex flex-col flex-1 mt-[20px]">
            <CardContent className="flex flex-col flex-1">
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="subtitle1" className=" font-bold">Recently Registered Users</Typography>
                </Box>

                <List className="flex-1">
                    {loading || parentLoading ? (
                        Array.from({ length: 4 }).map((_, i) => (
                            <React.Fragment key={i}>
                                <ListItem>
                                    <Skeleton variant="circular" width={40} height={40} animation="wave" />
                                    <div style={{ marginLeft: "15px", flex: 1 }}>
                                        <Skeleton variant="text" width="50%" animation="wave" />
                                        <Skeleton variant="text" width="30%" animation="wave" />
                                    </div>
                                </ListItem>
                                <Divider />
                            </React.Fragment>
                        ))
                    ) : Array.isArray(recentlyEnrolledPrograms) && recentlyEnrolledPrograms.length > 0 ? (
                        recentlyEnrolledPrograms.map((program) => (
                            <React.Fragment key={program.id}>
                                <ListItem onClick={() => { nav(`/admin/cases/caseDetails/${program?.id}`) }}>
                                    {/* Avatar with program icon */}
                                    <Avatar
                                        src={"/assets/userProfile.png"}
                                        alt={program?.name}
                                    />
                                    <div style={{ marginLeft: "15px" }}>
                                        <Typography variant="body1">
                                            {program?.name}
                                        </Typography>
                                        <Typography variant="body2" color="textSecondary">
                                            {program?.createdAt}
                                        </Typography>
                                    </div>
                                </ListItem>
                                <Divider />
                            </React.Fragment>
                        ))
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            No recent registrations found.
                        </Typography>
                    )}
                </List>

                {/* Button with total enrolled count */}
                <Box display="flex" justifyContent="flex-start" mt={2}>
                    <Button color="primary"
                        endIcon={<ChevronRightOutlinedIcon />}
                        sx={{ textTransform: 'none' }}
                        className="absolute left-0 bottom-0 max-w-[300px]"
                        onClick={handleClick}>
                        {totalEnrolled} Total Registered
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
};

export default Registration;
